module.exports = __webpack_public_path__ + "static/img/6.8435b68.png";


//////////////////
// WEBPACK FOOTER
// ./src/daoba-match/assets/internetimg/6.png
// module id = I3sc
// module chunks = 9